angular.module('property-price-list')
    .component('propertyPriceListHistory', {
        bindings: {
            propertyId: '<',
            propertyUid: '<'
        },
        templateUrl: 'app/property-price-list/price-history.html',
        controller: function ($scope, PropertyPriceList) {

            this.priceChangeOnly = true;

            this.$onInit = () => {
                this.load();
            };

            this.load = () => {
                PropertyPriceList.history({propertyId: this.propertyId, propertyUid: this.propertyUid, priceChangeOnly: this.priceChangeOnly}).$promise
                    .then(result => this.items = result);
            };

            this.togglePriceChangeOnly = () => {
                this.load();
            }

            $scope.$on('property-price-list.updated', () => this.$onInit());
        }
    })
